'use strict';

import { HttpErrorResponse } from '@angular/common/http';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';

export class GeneralHelper {
  static extractErrorMessage(error: any) {
    if (error.error_description) return error.error_description;
    else if (Array.isArray(error)) return this.generateArrayError(error);
    else if (error.error) return this.extractErrorMessage(error.error);
    else if (error.errorResponse) return this.extractErrorMessage(error.errors);
    else if (error.errors) return this.generateError(error.errors, ' ');
    else return error.toString();
  }

  static generateError(errors: any,space: string) {
    let errorMessage: string = '';
    errors.forEach(function(err){
      errorMessage = errorMessage + err.message + space;
    });
    return errorMessage;
  }

  static generateArrayError(errors: any) {
    let errorMessage: string = '';
    errors.forEach((err) => {
      errorMessage = errorMessage + '<br>' + ' แถวที่ ' + err.row + '<br>' + this.generateError(err.errorResponse.errors, '<br>');
    });
    return errorMessage;
  }
}



// WEBPACK FOOTER //
// ./src/app/helpers/general.helper.ts